import { useMemo } from 'react'
import { Modal } from '@opallabs/lapidary'
import { Footer } from './Footer'
import { useQueryableAddToPlanModal } from './forBackboneConsumers/QueryableAddToPlanModalContext'
import { ModalContent } from './ModalContent'
import * as styles from './styles'
import type { AddToPlanModalProps } from './types'
import { useAddToPlanState } from './useAddToPlanState'

export { useOnAddToPlan } from './queries/useOnAddToPlan'
export * from './AddToPlanToasts'

export const AddToPlanModal: React.FC<AddToPlanModalProps> = ({
  isOpen,
  momentData,
  onAddToPlan,
  onCloseModal,
}) => {
  const queryableContext = useQueryableAddToPlanModal()

  const moments = useMemo(() => {
    if (momentData) return momentData
    return queryableContext?.moments ?? []
  }, [momentData, queryableContext?.moments])

  const {
    actions,
    availableOptions,
    loadingStates,
    selectedOptions,
    validation,
  } = useAddToPlanState({
    moments,
    onAddToPlan: queryableContext?.onAddToPlan ?? onAddToPlan,
    onCloseModal,
  })

  return (
    <Modal.Root open={isOpen}>
      <Modal.Content
        css={styles.modalContent}
        key={moments.map(({ id }) => id.slice(0, 4)).join('')}
      >
        <Modal.Title>Add to Plan</Modal.Title>
        <Modal.Close onClick={() => onCloseModal()} />
        <Modal.Description className={styles.classes.descriptionClass}>
          Moments can be added to plans or blocks with plans.
        </Modal.Description>
        <Modal.Body css={styles.modalBody}>
          <ModalContent
            actions={actions}
            availableOptions={availableOptions}
            loadingStates={loadingStates}
            momentCount={moments.length}
            selectedOptions={selectedOptions}
            validation={validation}
          />
        </Modal.Body>
        <Footer
          addToPlan={actions.addToPlan}
          momentCount={moments.length}
          onCloseModal={onCloseModal}
          updateDisabled={validation.updateDisabled}
        />
      </Modal.Content>
    </Modal.Root>
  )
}
